









































































































































import { defineComponent } from '@vue/composition-api';

import CommonUnitSelector from '@/components/Delivery/CommonUnitSelector.vue';
import CommonProductTypeSelect from '../Product/CommonProductTypeSelect.vue';

const ItemOrderForWeight = defineComponent({
  components: { CommonUnitSelector, CommonProductTypeSelect },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toDecimalFormat = (string: string, digit = 2) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: digit, maximumFractionDigits: digit });

    function deliveryFeePerUnitInput($event: any) {
      emit('input', {
        ...props.value,
        deliveryFeePerUnit: $event,
        deliveryFee: props.value.count * $event,
      });
    }
    function countInput($event: any) {
      emit('input', {
        ...props.value,
        count: $event,
        deliveryFee: $event * props.value.deliveryFeePerUnit,
      });
    }
    function emitInput(key: string, $event: any) {
      emit('input', { ...props.value, [key]: $event });
    }

    return {
      toDecimalFormat,
      deliveryFeePerUnitInput,
      countInput,
      emitInput,
    };
  },
});

export default ItemOrderForWeight;
